export default __webpack_public_path__ + "static/media/payment-methods.14097047.svg";